import * as formatters from '@advisr/frontend-ui-components/src/utils/formatters'

const CurrencyFormattersPlugin = {
  install (Vue, options) {
    Vue.prototype.$currency = {
      format: formatters.formatCurrencyWithOptions,
      unformat: formatters.unformatCurrency
    }
  }
}

export default CurrencyFormattersPlugin
